module.exports = __webpack_public_path__ + "static/trainingImg-bb0ad7dc705aff1bb8bb6b48c4595284.svg";